'use strict';
module.exports = [
  '$scope',
  '$q',
  '$filter',
  '$stateParams',
  '$window',
  '$state',
  'situationRecordService',
  'datex2EnumsService',
  'sourceService',
  'errorHandlerService',
  'translateFilter',
  'situationRecordClass',
  'toastService',
  'sourceTranscodeFilter',
  'datex2EnumsTranscodeFilter',
  'zonedDateTimeToDateFilter',
  'clazzNodeFilter',
  'validityPeriodsToStringFilter',
  'clazzIconFilter',
  'keywordsService',
  'channelsService',
  function (
    $scope,
    $q,
    $filter,
    $stateParams,
    $window,
    $state,
    situationRecordService,
    datex2EnumsService,
    sourceService,
    errorHandlerService,
    translateFilter,
    situationRecordClass,
    toastService,
    sourceTranscodeFilter,
    datex2EnumsTranscodeFilter,
    zonedDateTimeToDateFilter,
    clazzNodeFilter,
    validityPeriodsToStringFilter,
    clazzIconFilter,
    keywordsService,
    channelsService
  ) {
    var mainConfig = global.ngDroAstralSituationRecordMainConfig;

    $scope.boxStatus = {
      mapIsOpen: true,
      filterIsOpen: false,
    };

    //                $scope.filterBoxStatus = {
    //                    isOpen: false
    //                };

    /**
     * Filtro di ricerca corrente
     */
    $scope.curFilter = {};

    /**
     * Filtro di ricerca mostrato nei chips
     */
    $scope.curFilterChips = {};

    //                var defaultFilterValidityPeriods = {
    //                    validityPeriodsDateStart: new Date(1900, 1, 1, 0, 0, 0)
    //                    , validityPeriodsDateEnd: new Date(3100, 1, 1, 0, 0, 0)
    //                };

    var defaultFilterTopLeft = {
      x: -180,
      y: 90,
      z: null,
    };
    var defaultFilterBottomRight = {
      x: 180,
      y: -90,
      z: null,
    };

    $scope.regionList = [
      {
        shortName: 'Lazio',
        longName: 'Lazio',
      },
      {
        shortName: 'Toscana',
        longName: 'Toscana',
      },
      {
        shortName: 'Umbria',
        longName: 'Umbria',
      },
      {
        shortName: 'Marche',
        longName: 'Marche',
      },
      {
        shortName: 'Abruzzo',
        longName: 'Abruzzo',
      },
      {
        shortName: 'Molise',
        longName: 'Molise',
      },
    ];

    $scope.provinceList = [
      {
        name: 'Lazio',
        provinces: [
          { shortName: 'RM', longName: 'Roma' },
          { shortName: 'LT', longName: 'Latina' },
          { shortName: 'FR', longName: 'Frosinone' },
          { shortName: 'RI', longName: 'Rieti' },
          { shortName: 'VT', longName: 'Viterbo' },
        ],
      },
      {
        name: 'Toscana',
        provinces: [
          { shortName: 'GR', longName: 'Grosseto' },
          { shortName: 'SI', longName: 'Siena' },
        ],
      },
      {
        name: 'Umbria',
        provinces: [{ shortName: 'TR', longName: 'Terni' }],
      },
      {
        name: 'Marche',
        provinces: [{ shortName: 'AP', longName: 'Ascoli Piceno' }],
      },
      {
        name: 'Abruzzo',
        provinces: [
          { shortName: 'AQ', longName: "L'Aquila" },
          { shortName: 'TE', longName: 'Teramo' },
        ],
      },
      {
        name: 'Molise',
        provinces: [{ shortName: 'IS', longName: 'Isernia' }],
      },
      {
        name: 'Campania',
        provinces: [{ shortName: 'CE', longName: 'Caserta' }],
      },
    ];

    $scope.keywordList = [];

    keywordsService.findAll(function (keywords) {
      $scope.keywordList = keywords;
    });

    $scope.checkIfKeywordIsSelected = function (keyword) {
      if ($scope.curFilter && $scope.curFilter.keywords) {
        for (var i = 0; i < $scope.curFilter.keywords.length; i++) {
          if ($scope.curFilter.keywords[i].id == keyword.id) {
            return true;
          }
        }
      }

      return false;
    };

    $scope.toggleKeyword = function (keyword) {
      if (!$scope.curFilter) {
        $scope.curFilter = {};
      }

      if (!$scope.curFilter.keywords) {
        $scope.curFilter.keywords = [];
        $scope.curFilterChips.keywords = [];
      }

      if (
        $scope.curFilter.keywords.find(function (k) {
          return k.id == keyword.id;
        })
      ) {
        $scope.curFilter.keywords = $scope.curFilter.keywords.filter(function (k) {
          return k.id != keyword.id;
        });

        if (
          $scope.curFilterChips.keywords.find(function (k) {
            return k.id == keyword.id;
          })
        ) {
          if (
            $scope.curFilterChips.keywords.find(function (k) {
              return k.id == keyword.id;
            })
          ) {
            if (keyword.checked) {
              $scope.curFilterChips.keywords.find(function (k) {
                return k.id == keyword.id;
              }).checked = true;

              $scope.curFilter.keywords.push(keyword);
            } else {
              $scope.curFilterChips.keywords = $scope.curFilterChips.keywords.filter(function (k) {
                return k.id != keyword.id;
              });
            }
          }
        } else {
          $scope.curFilterChips.keywords.push(keyword);
        }
      } else {
        $scope.curFilter.keywords.push(keyword);

        if (
          !$scope.curFilterChips.keywords.find(function (k) {
            return k.id == keyword.id;
          })
        ) {
          $scope.curFilterChips.keywords.push(keyword);
        } else {
          $scope.curFilter.keywords.find(function (k) {
            return k.id == keyword.id;
          }).checked = true;

          $scope.curFilterChips.keywords.find(function (k) {
            return k.id == keyword.id;
          }).checked = true;
        }
      }
    };

    $scope.channelList = [];

    channelsService.findAll(function (channels) {
      $scope.channelList = channels;
    });

    $scope.checkIfChannelIsSelected = function (channel) {
      if ($scope.curFilter && $scope.curFilter.channels) {
        for (var i = 0; i < $scope.curFilter.channels.length; i++) {
          if ($scope.curFilter.channels[i].id == channel.id) {
            return true;
          }
        }
      }

      return false;
    };

    $scope.toggleChannel = function (channel) {
      if (!$scope.curFilter) {
        $scope.curFilter = {};
      }

      if (!$scope.curFilter.channels) {
        $scope.curFilter.channels = [];
        $scope.curFilterChips.channels = [];
      }

      if (
        $scope.curFilter.channels.find(function (k) {
          return k.id == channel.id;
        })
      ) {
        $scope.curFilter.channels = $scope.curFilter.channels.filter(function (k) {
          return k.id != channel.id;
        });

        if (
          $scope.curFilterChips.channels.find(function (k) {
            return k.id == channel.id;
          })
        ) {
          if (
            $scope.curFilterChips.channels.find(function (k) {
              return k.id == channel.id;
            })
          ) {
            if (channel.checked) {
              $scope.curFilterChips.channels.find(function (k) {
                return k.id == channel.id;
              }).checked = true;

              $scope.curFilter.channels.push(channel);
            } else {
              $scope.curFilterChips.channels = $scope.curFilterChips.channels.filter(function (k) {
                return k.id != channel.id;
              });
            }
          }
        } else {
          $scope.curFilterChips.channels.push(channel);
        }
      } else {
        $scope.curFilter.channels.push(channel);

        if (
          !$scope.curFilterChips.channels.find(function (k) {
            return k.id == channel.id;
          })
        ) {
          $scope.curFilterChips.channels.push(channel);
        } else {
          $scope.curFilter.channels.find(function (k) {
            return k.id == channel.id;
          }).checked = true;

          $scope.curFilterChips.channels.find(function (k) {
            return k.id == channel.id;
          }).checked = true;
        }
      }
    };

    //*********************************************************************
    //**************************PAGINAZIONE****************************
    //*********************************************************************

    $scope.pagination = {
      page: 1,
      size: parseInt(mainConfig.PageSize),
      //sort: "createdDate,DESC",
      totItems: 0,
    };

    //*********************************************************************

    //*******************************************************************
    //********************        EXPORT TO CSV               ***********
    //*******************************************************************

    $scope.getCSVHeader = function () {
      return situationRecordClass.getCSVHeader();
    };

    $scope.getCSVData = function () {
      var deferred = $q.defer();

      searchSituationRecord($scope.curFilter).then(
        function () {
          var searchRes = $scope.situationRecordSearchResponse.content;

          var ret = situationRecordClass.getCSVData(
            searchRes,
            $scope.situationRecordTypesTree,
            $scope.situationRecordSources,
            $scope.datex2Enums
          );
          deferred.resolve(ret);
        },
        function (errors) {
          errorHandler(errors);
          deferred.reject();
        }
      );

      return deferred.promise;
    };

    $scope.CSV = {
      separator: ';',
      filename: translateFilter('AstralSituationRecord.eventSearch') + '.csv',
    };

    //*******************************************************************

    //                //*******************************************************************
    //                //********************        ORDINAMENTO TABELLA        ************
    //                //*******************************************************************

    /**
     * JSON contente la gerarchia di classi che implementa il Situation Record
     */
    $scope.situationRecordTypesTree = undefined;
    /**
     * Lista delle classi concrete (foglie dell'albero della gerarchia) che implementano il Situation Record
     */
    $scope.situationRecordTypesLeaves = undefined;
    /**
     * Enumerazioni Datex2
     */
    $scope.datex2Enums = undefined;
    /**
     * Sources
     */
    $scope.situationRecordSources = undefined;

    /**
     * Caricamento Situation Record Source
     * @return {deferred.promise}
     */
    function getSources() {
      var deferred = $q.defer();
      var params = {
        page: 0,
        size: 1000,
        sort: 'comment.comment.keyword',
      };
      sourceService.getAll(
        params,
        function (res) {
          $scope.situationRecordSources = res.content;

          deferred.resolve();
        },
        function (errors) {
          errorHandler(errors);

          deferred.reject();
        }
      );
      return deferred.promise;
    }

    /**
     * Caricamento Enumerazioni Datex2
     * @return {deferred.promise}
     */
    function getDatex2Enums() {
      var deferred = $q.defer();
      datex2EnumsService.getDatex2Enums(
        function (res) {
          if (res) {
            $scope.datex2Enums = angular.fromJson(res);
          }
          $scope.severityList = [];

          deferred.resolve();
        },
        function (errors) {
          errorHandler(errors);

          deferred.reject();
        }
      );
      return deferred.promise;
    }
    /**
     * Caricamento tipi situation record
     * @return {.$q@call;defer.promise}
     */
    function getSituationRecordTypesTree() {
      var deferred = $q.defer();
      situationRecordService.situationRecordGetTypes(
        function (res) {
          $scope.situationRecordTypesTree = res.children;

          deferred.resolve();
        },
        function (errors) {
          errorHandler(errors);

          deferred.reject();
        }
      );
      return deferred.promise;
    }

    function getSituationRecordTypesLeaves() {
      if ($scope.situationRecordTypesTree) {
        $scope.situationRecordTypesLeaves = [];
        angular.forEach($scope.situationRecordTypesTree, function (item) {
          setSituationRecordTypesLeaves(item);
        });
      }
    }
    function setSituationRecordTypesLeaves(item) {
      if (item.children && item.children.length) {
        //nodo intermedio
        angular.forEach(item.children, function (child) {
          setSituationRecordTypesLeaves(child);
        });
      } else {
        //foglia
        $scope.situationRecordTypesLeaves.push(item);
      }
    }

    //*********************************************************************
    //**************************GESTIONE TYPEAHEAD CAUSA ******************
    //*********************************************************************
    $scope.causeMgmt = {
      type: 'enum',
      eventId: undefined,
      enumVal: undefined,
    };
    $scope.thIsCauseAccordionCollapsed = true;
    $scope.thCauseSelected = undefined;

    $scope.thCauseReset = function () {
      $scope.causeMgmt.eventId = undefined;
      $scope.curFilter.cause = undefined;
      $scope.thCauseSelected = undefined;
      $scope.thIsCauseAccordionCollapsed = true;
    };

    $scope.thCauseSearch = function (comment) {
      var d1 = new Date();

      var defaultFilter = getDefaultFilter();

      var filter = {
        //                        validityPeriodsDateStart: defaultFilter.validityPeriodsDateStart,
        //                        validityPeriodsDateEnd: defaultFilter.validityPeriodsDateEnd,
        comment: comment,
      };

      return searchSituationRecord(filter).then(function () {
        $scope.thCauseResults = [];
        if ($scope.situationRecordSearchResponse && $scope.situationRecordSearchResponse.content) {
          for (var j = 0; j < $scope.situationRecordSearchResponse.content.length; j++) {
            if ($scope.situationRecordSearchResponse.content[j]) {
              for (
                var i = 0;
                i < $scope.situationRecordSearchResponse.content[j].comments.length;
                i++
              ) {
                var item = {
                  comment:
                    translateFilter('AstralSituationRecord.id') +
                    ': ' +
                    $scope.situationRecordSearchResponse.content[j].id +
                    '-' +
                    $scope.situationRecordSearchResponse.content[j].comments[i].comment,
                  id: $scope.situationRecordSearchResponse.content[j].id,
                };

                $scope.thCauseResults.push(item);
              }
            }
          }
        }

        return $scope.thCauseResults;
      });
    };

    $scope.thCauseOnSelect = function (item) {
      if (item) {
        //$scope.curSituationRecord.cause = item.id;
        $scope.causeMgmt = {
          type: 'eventId',
          eventId: item.id,
          enumVal: undefined,
        };
      }
    };

    //*********************************************************************

    //*********************************************************************
    //**************************GESTIONE ERRORE ***************************
    //*********************************************************************
    /**
     * Management errori di validaziione riscontrati al salvataggio
     * @return {undefined}
     */
    function errorHandler(error, successMessage, errorMessage) {
      var validationErrors = [];
      errorHandlerService.handle(error, successMessage, errorMessage).then(function (validErrors) {
        validationErrors = validErrors;
        if (validErrors)
          toastService.createErrorToast(translateFilter('AstralSituationRecord.notValidParameter'));
      });
    }

    //*********************************************************************

    //*********************************************************************
    //**************************RICERCA EVENTI ****************************
    //*********************************************************************

    /**
     * Risultato ricerca eventi
     */
    $scope.situationRecordSearchResponse = undefined;
    $scope.situationRecordSearch = [];

    $scope.search = function () {
      if ($scope.causeMgmt) {
        if ($scope.causeMgmt.type && $scope.causeMgmt.type === 'enum') {
          if ($scope.causeMgmt.enumVal !== undefined && $scope.causeMgmt.enumVal.trim() === '')
            $scope.causeMgmt.enumVal = undefined;

          $scope.curFilter.cause = $scope.causeMgmt.enumVal;
        }
        if ($scope.causeMgmt.type && $scope.causeMgmt.type === 'eventId') {
          $scope.curFilter.cause = $scope.causeMgmt.eventId;
        }
      }

      //                    if ($scope.curFilter.eventType !== undefined && $scope.curFilter.eventType === "") {
      //                        $scope.curFilter.eventType = undefined;
      //                    }

      if ($scope.curFilter.source !== undefined && $scope.curFilter.source === '') {
        $scope.curFilter.source = undefined;
      }
      if (!$scope.curFilter.publicSiteEvidence) $scope.curFilter.publicSiteEvidence = undefined;
      if (!$scope.curFilter.isValid) $scope.curFilter.isValid = undefined;
      if ($scope.curFilter.confidentiality === undefined) {
        $scope.curFilter.confidentiality = undefined;
        $scope.curFilter.confidentialityList = undefined;
      } else {
        $scope.curFilter.confidentialityList = [];
        $scope.curFilter.confidentialityList.push($scope.curFilter.confidentiality);
      }

      if (
        $scope.curFilter.probabilityOfOccurrence !== undefined &&
        $scope.curFilter.probabilityOfOccurrence.trim() === ''
      )
        $scope.curFilter.probabilityOfOccurrence = undefined;
      if ($scope.curFilter.severity !== undefined && $scope.curFilter.severity.trim() === '')
        $scope.curFilter.severity = undefined;

      $scope.situationRecordSearch = [];

      searchSituationRecord(
        $scope.curFilter,
        $scope.pagination.page,
        $scope.pagination.size,
        $scope.pagination.sort
      ).then(
        function () {
          $scope.situationRecordSearch = $scope.situationRecordSearchResponse.content;
          //$scope.curTotItems = $scope.situationRecordSearchResponse.totalElements;
          $scope.pagination.totItems = $scope.situationRecordSearchResponse.totalElements;
          if (!$scope.situationRecordSearch || $scope.situationRecordSearch.length === 0) {
            var msg = translateFilter('AstralSituationRecord.noResultFound');
            //$scope.curTotItems = 0;
            $scope.pagination.totItems = 0;
            toastService.createWarningToast(msg);
          } else {
            $scope.boxStatus.filterIsOpen = false;
            //                            $scope.filterBoxStatus = {
            //                                isOpen: false
            //                            };
          }
          MarkerEventInitialize();
        },
        function (errors) {
          errorHandler(errors);
        }
      );
    };
    /**
     * Ricerca eventi
     * @param {type} filter
     * @param {type} page
     * @param {type} size
     * @param {type} sort
     * @return {.$q@call;defer.promise}
     */
    function searchSituationRecord(filter, page, size, sort) {
      var deferred = $q.defer();

      $scope.situationRecordSearchResponse = undefined;
      //verifica dei filtri impostati
      if (!filter) {
        filter = {};
      }

      //CREO UNA COPIA DEL FILTRO PERCHE' NON VOGLIO CHE I DEFAULT IMPOSTATI VENGANO RIPORTATI SUL PANNELLO DI SELEZIONE FILTRI
      var filterCopy = angular.copy(filter, filterCopy);

      if (filter.eventTypeList) {
        filterCopy.eventTypeList = [];
        angular.forEach(filter.eventTypeList, function (val, key) {
          if (val) {
            filterCopy.eventTypeList.push(key);
          }
        });
      }

      // var d1 = new Date();
      filterCopy.clazz = situationRecordClass.getSituationRecordTypes().situationRecordFilter;
      //                    if (!filterCopy.validityPeriodsDateStart) {
      //                        filterCopy.validityPeriodsDateStart = defaultFilterValidityPeriods.validityPeriodsDateStart;
      //                    }
      //                    if (!filterCopy.validityPeriodsDateEnd) {
      //                        filterCopy.validityPeriodsDateEnd = defaultFilterValidityPeriods.validityPeriodsDateEnd;
      //                    }

      if (!filterCopy.topLeft) filterCopy.topLeft = defaultFilterTopLeft;

      if (!filterCopy.bottomRight) filterCopy.bottomRight = defaultFilterBottomRight;

      //                    if (filterCopy.eventType) {
      //                        filterCopy.eventTypeList = [filter.eventType];
      //                    } else {
      //                        filterCopy.eventTypeList = undefined;
      //                    }

      if (filterCopy.source) {
        filterCopy.sourceList = [filter.source];
      } else {
        filterCopy.sourceList = undefined;
      }

      if (filterCopy.region === '') {
        delete filterCopy.region;
      }

      if (filterCopy.province === '') {
        delete filterCopy.province;
      }

      if ($scope.curFilterChips.keywords && $scope.curFilterChips.keywords.length) {
        filterCopy.keywords = $scope.curFilterChips.keywords
          .filter(function (el) {
            return el.checked === true;
          })
          .map(function (el) {
            delete el.$$hashKey;
            return el;
          });
      }

      if ($scope.curFilterChips.keywords && !$scope.curFilterChips.keywords.length) {
        delete filterCopy.keywords;
      }

      if ($scope.curFilterChips.channels && $scope.curFilterChips.channels.length) {
        filterCopy.channels = $scope.curFilterChips.channels
          .filter(function (el) {
            return el.checked === true;
          })
          .map(function (el) {
            delete el.$$hashKey;
            return el;
          });
      }

      if ($scope.curFilterChips.channels && !$scope.curFilterChips.channels.length) {
        delete filterCopy.channels;
      }

      var params = {};
      if (page !== undefined) params.page = page - 1;
      if (size) params.size = size;
      if (sort) params.sort = sort;

      situationRecordService.search(
        params,
        filterCopy,
        function (res) {
          $scope.situationRecordSearchResponse = res;

          deferred.resolve();
        },
        function (errors) {
          errorHandler(errors);

          deferred.reject();
        }
      );
      return deferred.promise;
    }
    //*********************************************************************

    //*********************************************************************
    //********************************** MAPPA ****************************
    //*********************************************************************

    /**
     * Model della mappa
     */
    $scope.myMap = {
      mapId: 'mapSearch',
      zoom: 11,
      centerLat: 41.89,
      centerLng: 12.5,
      showDrawing: false,
      enablePath: false,
      enableMarkerDraw: false,
      parentObjEditable: false,
      mapDivStyle: { height: '800px' },
      mapStyle: {
        height: '500px',
        width: '100%',
        position: 'relative',
        display: 'block',
      },
    };
    $scope.markers = [];
    $scope.directions = {};
    $scope.shapes = [];

    function MarkerEventInitialize() {
      var markers = [];

      if ($scope.situationRecordSearch) {
        angular.forEach($scope.situationRecordSearch, function (sr) {
          if (sr.location && sr.location.coordinates) {
            var desc = '';
            if (sr.comments && sr.comments.length > 0 && sr.comments[0].comment) {
              desc = sr.comments[0].comment;
            }

            var markerEvent = {
              idevent: sr.id,
              lon: sr.location.coordinates[0][0],
              lat: sr.location.coordinates[0][1],
              icon: clazzIconFilter(sr.clazz),
              description: desc,
            };
            markers.push(markerEvent);
          }
        });
      }

      $scope.markers = markers;

      if ($scope.markers[0]) {
        $scope.myMap.centerLat = $scope.markers[0].lat;
        $scope.myMap.centerLng = $scope.markers[0].lon;
      }
    }

    function setMapHeight() {
      var windowHeight = $(window).outerHeight();

      $scope.myMap.mapDivStyle.height = windowHeight - windowHeight / 4.5;
      $scope.myMap.mapStyle.height = windowHeight - windowHeight / 4.5;
    }
    $scope.focusinControl = {};
    $scope.mapReady = function () {
      $scope.focusinControl.resetMap();
    };

    $scope.mapLayers = [];

    //                function initMapLayers() {
    //
    //                    // RESET
    //                    for (var i = 0; i < numMapLayers; i++) {
    //
    //                        var mapLayersItem = {
    //                            showLayer: false,
    //                            jsonLayer: [],
    //                            "icon": "",
    //                            idx: i
    //                        };
    //
    //                        $scope.mapLayers.push(mapLayersItem);
    //                    }
    //
    //                }

    $scope.mapShapes = function (shapes) {};

    $scope.mapDirections = function (route, waypoint) {};

    $scope.mapMarkers = function (markers) {};

    $scope.mapMarkerOpenEvent = function (marker) {
      $state.go('situation-record-mgmt', { id: marker.idevent });
    };

    $scope.mapBoundChangeEvent = function (mapbounds) {};

    //*********************************************************************

    //****************************************************************************************
    //                          COLLEGAMENTO SELEZIONE MAPPA/SELEZIONE TABELLA RISULTATI
    //****************************************************************************************

    /**
     * Situation Record Id selezionato sulla tabella risultati
     */
    $scope.tableActiveId = undefined;
    /**
     * Situation Record Id selezionato sulla mappa
     */
    $scope.mapActiveId = undefined;

    /**
     * Handler evento marker click
     * @param {type} marker
     * @return {undefined}
     */
    $scope.onMarkerClickEvent = function (marker) {
      if (marker && marker.idevent) {
        $scope.tableActiveId = marker.idevent;
        $scope.$apply();
      }
    };
    /**
     * Handler on-situation-record-selected sulla tabella risultati
     * @param {type} item
     * @return {undefined}
     */
    $scope.onSRTableSelected = function (item) {
      if (item) {
        $scope.tableActiveId = item.id;
        $scope.mapActiveId = item.id;
      }
    };

    //****************************************************************************************

    //*********************************************************************
    //************************** CHIP FILTRI DI RICERCA *******************
    //*********************************************************************
    /**
     * Riallineamento filtri-chips quando viene cambiato il filtro
     * @param {type} filterItem
     * @return {undefined}
     */
    $scope.curFilterChange = function (filterItem) {
      switch (filterItem) {
        //                        case "eventType":
        //                            if ($scope.curFilter.eventType) {
        //                                $scope.curFilterChips.eventType = clazzNodeFilter($scope.curFilter.eventType, $scope.situationRecordTypesTree);
        //                                $scope.curFilterChips.eventTypeChecked = true;
        //                            } else {
        //                                $scope.curFilterChips.eventType = undefined;
        //                                $scope.curFilterChips.eventTypeChecked = false;
        //                            }
        //                            break;
        case 'eventTypeList':
          if ($scope.curFilter.eventTypeList) {
            $scope.curFilterChips.eventTypeList = [];
            $scope.curFilterChips.eventTypeListChecked = {};
            angular.forEach($scope.curFilter.eventTypeList, function (val, key) {
              if (val) {
                $scope.curFilterChips.eventTypeList.push(
                  clazzNodeFilter(key, $scope.situationRecordTypesTree)
                );
                //$scope.curFilterChips.eventTypeListChecked.splice(key,0,val);
                $scope.curFilterChips.eventTypeListChecked[key] = val;
              }
            });
          } else {
            $scope.curFilterChips.eventTypeList = undefined;
            $scope.curFilterChips.eventTypeListChecked = undefined;
          }
          break;
        case 'id':
          if ($scope.curFilter.id) {
            $scope.curFilterChips.id = $scope.curFilter.id;
            $scope.curFilterChips.idChecked = true;
          } else {
            $scope.curFilterChips.id = undefined;
            $scope.curFilterChips.idChecked = false;
          }
          break;
        case 'validityPeriodsDateStart':
          if ($scope.curFilter.validityPeriodsDateStart) {
            $scope.curFilterChips.validityPeriodsDateStart =
              $scope.curFilter.validityPeriodsDateStart;
            $scope.curFilterChips.validityPeriodsDateStartChecked = true;
          } else {
            $scope.curFilterChips.validityPeriodsDateStart = undefined;
            $scope.curFilterChips.validityPeriodsDateStartChecked = false;
          }
          break;
        case 'validityPeriodsDateEnd':
          if ($scope.curFilter.validityPeriodsDateEnd) {
            $scope.curFilterChips.validityPeriodsDateEnd = $scope.curFilter.validityPeriodsDateEnd;
            $scope.curFilterChips.validityPeriodsDateEndChecked = true;
          } else {
            $scope.curFilterChips.validityPeriodsDateEnd = undefined;
            $scope.curFilterChips.validityPeriodsDateEndChecked = false;
          }
          break;
        case 'createdDateStart':
          if ($scope.curFilter.createdDateStart) {
            $scope.curFilterChips.createdDateStart = $scope.curFilter.createdDateStart;
            $scope.curFilterChips.createdDateStartChecked = true;
          } else {
            $scope.curFilterChips.createdDateStart = undefined;
            $scope.curFilterChips.createdDateStartChecked = false;
          }
          break;
        case 'createdDateEnd':
          if ($scope.curFilter.createdDateEnd) {
            $scope.curFilterChips.createdDateEnd = $scope.curFilter.createdDateEnd;
            $scope.curFilterChips.createdDateEndChecked = true;
          } else {
            $scope.curFilterChips.createdDateEnd = undefined;
            $scope.curFilterChips.createdDateEndChecked = false;
          }
          break;
        case 'source':
          if ($scope.curFilter.source) {
            $scope.curFilterChips.source = $scope.curFilter.source;
            $scope.curFilterChips.sourceChecked = true;
          } else {
            $scope.curFilterChips.source = undefined;
            $scope.curFilterChips.sourceChecked = false;
          }
          break;
        case 'publicSiteEvidence':
          if ($scope.curFilter.publicSiteEvidence) {
            $scope.curFilterChips.publicSiteEvidence = $scope.curFilter.publicSiteEvidence;
            $scope.curFilterChips.publicSiteEvidenceChecked = true;
          } else {
            $scope.curFilterChips.publicSiteEvidence = undefined;
            $scope.curFilterChips.publicSiteEvidenceChecked = false;
          }
          break;
        case 'isValid':
          if ($scope.curFilter.isValid) {
            $scope.curFilterChips.isValid = $scope.curFilter.isValid;
            $scope.curFilterChips.isValidChecked = true;
          } else {
            $scope.curFilterChips.isValid = undefined;
            $scope.curFilterChips.isValidChecked = false;
          }
          break;
        //                        TODO: case "cause":
        //                            if ($scope.curFilter.cause) {
        //                                $scope.curFilterChips.cause = $scope.curFilter.cause;
        //                                $scope.curFilterChips.causeChecked = true;
        //                            } else {
        //                                $scope.curFilterChips.cause = undefined;
        //                                $scope.curFilterChips.causeChecked = false;
        //                            }
        //                            break;
        case 'confidentiality':
          if ($scope.curFilter.confidentiality) {
            $scope.curFilterChips.confidentiality = $scope.curFilter.confidentiality;
            $scope.curFilterChips.confidentialityChecked = true;
          } else {
            $scope.curFilterChips.confidentiality = undefined;
            $scope.curFilterChips.confidentialityChecked = false;
          }
          break;
        case 'probabilityOfOccurrence':
          if ($scope.curFilter.probabilityOfOccurrence) {
            $scope.curFilterChips.probabilityOfOccurrence =
              $scope.curFilter.probabilityOfOccurrence;
            $scope.curFilterChips.probabilityOfOccurrenceChecked = true;
          } else {
            $scope.curFilterChips.probabilityOfOccurrence = undefined;
            $scope.curFilterChips.probabilityOfOccurrenceChecked = false;
          }
          break;
        case 'severity':
          if ($scope.curFilter.severity) {
            $scope.curFilterChips.severity = $scope.curFilter.severity;
            $scope.curFilterChips.severityChecked = true;
          } else {
            $scope.curFilterChips.severity = undefined;
            $scope.curFilterChips.severityChecked = false;
          }
          break;
        case 'comment':
          if ($scope.curFilter.comment) {
            $scope.curFilterChips.comment = $scope.curFilter.comment;
            $scope.curFilterChips.commentChecked = true;
          } else {
            $scope.curFilterChips.comment = undefined;
            $scope.curFilterChips.commentChecked = false;
          }
          break;
        case 'region':
          if ($scope.regionList) {
            $scope.curFilterChips.region = $scope.curFilter.region;
            $scope.curFilterChips.regionChecked = true;
          } else {
            $scope.curFilterChips.region = undefined;
            $scope.curFilterChips.regionChecked = false;
          }
          break;
        case 'province':
          if ($scope.provinceList) {
            $scope.curFilterChips.province = $scope.curFilter.province;
            $scope.curFilterChips.provinceChecked = true;
          } else {
            $scope.curFilterChips.province = undefined;
            $scope.curFilterChips.provinceChecked = false;
          }
          break;

        case 'keywords':
          if ($scope.curFilter.keywords) {
            $scope.curFilterChips.keywords.forEach(function (keyword) {
              if (keyword.checked) {
                $scope.keywordList.find(function (element) {
                  return element.id === keyword.id;
                }).checked = true;

                $scope.curFilter.keywords.find(function (element) {
                  return element.id === keyword.id;
                }).checked = true;
              } else {
                $scope.keywordList.find(function (element) {
                  return element.id === keyword.id;
                }).checked = false;

                $scope.curFilter.keywords.find(function (element) {
                  return element.id === keyword.id;
                }).checked = false;
              }
            });
          }
          break;

        case 'channels':
          if ($scope.curFilter.channels) {
            $scope.curFilterChips.channels.forEach(function (channel) {
              if (channel.checked) {
                $scope.channelList.find(function (element) {
                  return element.id === channel.id;
                }).checked = true;

                $scope.curFilter.channels.find(function (element) {
                  return element.id === channel.id;
                }).checked = true;
              } else {
                $scope.channelList.find(function (element) {
                  return element.id === channel.id;
                }).checked = false;

                $scope.curFilter.channels.find(function (element) {
                  return element.id === channel.id;
                }).checked = false;
              }
            });
          }
          break;

        default:
          break;
      }
    };

    $scope.provincesChange = function (event) {
      $scope.curFilter.provinceList = event.provinceList;
      // $scope.curFilterChips.provinceListChecked = event.provinceList.length > 0;
    };

    /**
     * Riallineamento filtri-chips quando viene selezionato/deselezionato il chip
     * @param {type} filterItem
     * @return {undefined}
     */
    $scope.curFilterChipsChange = function (filterItem) {
      switch (filterItem) {
        //                        case "eventType":
        //                            if ($scope.curFilterChips.eventTypeChecked) {
        //                                $scope.curFilter.eventType = $scope.curFilterChips.eventType.element;
        //                            } else {
        //                                $scope.curFilter.eventType = undefined;
        //                            }
        //                            break;
        case 'eventTypeList':
          if ($scope.curFilterChips.eventTypeListChecked) {
            $scope.curFilter.eventTypeList = $scope.curFilterChips.eventTypeListChecked;
          } else {
            $scope.curFilter.eventTypeList = undefined;
          }
          break;
        case 'id':
          if ($scope.curFilterChips.idChecked) {
            $scope.curFilter.id = $scope.curFilterChips.id;
          } else {
            $scope.curFilter.id = undefined;
          }
          break;
        case 'validityPeriodsDateStart':
          if ($scope.curFilterChips.validityPeriodsDateStartChecked) {
            $scope.curFilter.validityPeriodsDateStart =
              $scope.curFilterChips.validityPeriodsDateStart;
          } else {
            $scope.curFilter.validityPeriodsDateStart = undefined;
          }
          break;
        case 'validityPeriodsDateEnd':
          if ($scope.curFilterChips.validityPeriodsDateEndChecked) {
            $scope.curFilter.validityPeriodsDateEnd = $scope.curFilterChips.validityPeriodsDateEnd;
          } else {
            $scope.curFilter.validityPeriodsDateEnd = undefined;
          }
          break;
        case 'createdDateStart':
          if ($scope.curFilterChips.createdDateStartChecked) {
            $scope.curFilter.createdDateStart = $scope.curFilterChips.createdDateStart;
          } else {
            $scope.curFilter.createdDateStart = undefined;
          }
          break;
        case 'createdDateEnd':
          if ($scope.curFilterChips.createdDateEndChecked) {
            $scope.curFilter.createdDateEnd = $scope.curFilterChips.createdDateEnd;
          } else {
            $scope.curFilter.createdDateEnd = undefined;
          }
          break;
        case 'source':
          if ($scope.curFilterChips.sourceChecked) {
            $scope.curFilter.source = $scope.curFilterChips.source;
          } else {
            $scope.curFilter.source = undefined;
          }
          break;
        case 'publicSiteEvidence':
          if ($scope.curFilterChips.publicSiteEvidenceChecked) {
            $scope.curFilter.publicSiteEvidence = $scope.curFilterChips.publicSiteEvidence;
          } else {
            $scope.curFilter.publicSiteEvidence = undefined;
          }
          break;
        case 'isValid':
          if ($scope.curFilterChips.isValidChecked) {
            $scope.curFilter.isValid = $scope.curFilterChips.isValid;
          } else {
            $scope.curFilter.isValid = undefined;
          }
          break;

        //                        TODO: case "cause":
        //                            if ($scope.curFilterChips.causeChecked) {
        //                                $scope.curFilter.cause = $scope.curFilterChips.cause;
        //                            } else {
        //                                $scope.curFilter.cause = undefined;
        //                            }
        //                            break;

        case 'confidentiality':
          if ($scope.curFilterChips.confidentialityChecked) {
            $scope.curFilter.confidentiality = $scope.curFilterChips.confidentiality;
          } else {
            $scope.curFilter.confidentiality = undefined;
          }
          break;
        case 'probabilityOfOccurrence':
          if ($scope.curFilterChips.probabilityOfOccurrenceChecked) {
            $scope.curFilter.probabilityOfOccurrence =
              $scope.curFilterChips.probabilityOfOccurrence;
          } else {
            $scope.curFilter.probabilityOfOccurrence = undefined;
          }
          break;
        case 'severity':
          if ($scope.curFilterChips.severityChecked) {
            $scope.curFilter.severity = $scope.curFilterChips.severity;
          } else {
            $scope.curFilter.severity = undefined;
          }
          break;
        case 'comment':
          if ($scope.curFilterChips.commentChecked) {
            $scope.curFilter.comment = $scope.curFilterChips.comment;
          } else {
            $scope.curFilter.comment = undefined;
          }
          break;
        case 'region':
          if ($scope.curFilterChips.regionChecked) {
            $scope.curFilter.region = $scope.curFilterChips.region;
          } else {
            $scope.curFilter.region = undefined;
          }
          break;
        case 'province':
          if ($scope.curFilterChips.provinceChecked) {
            $scope.curFilter.province = $scope.curFilterChips.province;
          } else {
            $scope.curFilter.province = undefined;
          }
          break;
        case 'keywords':
          $scope.curFilterChips.keywords.forEach(function (keyword) {
            if (keyword.checked) {
              $scope.keywordList.find(function (element) {
                return element.id === keyword.id;
              }).checked = true;

              $scope.curFilter.keywords.find(function (element) {
                return element.id === keyword.id;
              }).checked = true;
            } else {
              $scope.keywordList.find(function (element) {
                return element.id === keyword.id;
              }).checked = false;

              $scope.curFilter.keywords.find(function (element) {
                return element.id === keyword.id;
              }).checked = false;
            }
          });
          break;
        case 'channels':
          $scope.curFilterChips.channels.forEach(function (channel) {
            if (channel.checked) {
              $scope.channelList.find(function (element) {
                return element.id === channel.id;
              }).checked = true;

              $scope.curFilter.channels.find(function (element) {
                return element.id === channel.id;
              }).checked = true;
            } else {
              $scope.channelList.find(function (element) {
                return element.id === channel.id;
              }).checked = false;

              $scope.curFilter.channels.find(function (element) {
                return element.id === channel.id;
              }).checked = false;
            }
          });
          break;

        default:
          break;
      }
    };

    /**
     *  Riallineamento tutti filtri-chips
     * @return {undefined}
     */
    function setCurFilterChips() {
      $scope.curFilterChips = JSON.parse(JSON.stringify($scope.curFilter));
      //                    $scope.curFilterChange("eventType");
      $scope.curFilterChange('eventTypeList');
      $scope.curFilterChange('id');
      $scope.curFilterChange('validityPeriodsDateStart');
      $scope.curFilterChange('validityPeriodsDateEnd');
      $scope.curFilterChange('createdDateStart');
      $scope.curFilterChange('createdDateEnd');
      $scope.curFilterChange('source');
      $scope.curFilterChange('publicSiteEvidence');
      $scope.curFilterChange('isValid');
      //TODO: $scope.curFilterChange ("cause");
      $scope.curFilterChange('confidentiality');
      $scope.curFilterChange('probabilityOfOccurrence');
      $scope.curFilterChange('severity');
      $scope.curFilterChange('comment');
      $scope.curFilterChange('region');
      $scope.curFilterChange('province');
      $scope.curFilterChange('keywords');
      $scope.curFilterChange('channels');
    }
    //*********************************************************************

    //*********************************************************************
    //**************************GESTIONE EVENTI ****************************
    //*********************************************************************
    //
    //*********************************************************************

    function getDefaultFilter() {
      var defaultFilter = {
        clazz: situationRecordClass.getSituationRecordTypes().situationRecordFilter,
        id: undefined,
        validityPeriodsDateStart: undefined,
        validityPeriodsDateEnd: undefined,
        topLeft: undefined,
        bottomRight: undefined,
        //                        , eventType: undefined
        eventTypeList: undefined,
        eventTypeList: undefined,
        createdDateStart: undefined,
        createdDateEnd: undefined,
        severity: undefined,
        validityStatus: undefined,
        probabilityOfOccurrence: undefined,
        confidentiality: undefined,
        cause: undefined,
        source: undefined,
        sourceList: undefined,
        comment: undefined,
        publicSiteEvidence: undefined,
        isValid: true,
        comment: undefined,
        region: undefined,
        province: undefined,
        keywords: [],
        channels: [],
      };
      return defaultFilter;
    }

    $scope.resetFilter = function () {
      $scope.curFilter = getDefaultFilter();

      setCurFilterChips();

      $scope.keywordList.forEach(function (keyword) {
        keyword.checked = false;
      });

      $scope.channelList.forEach(function (channel) {
        channel.checked = false;
      });

      $scope.thCauseReset();
    };

    (function init() {
      getSituationRecordTypesTree().then(function () {
        getSituationRecordTypesLeaves();
        getDatex2Enums().then(function () {
          getSources().then(function () {
            $scope.resetFilter();
            if ($stateParams.curSearchFilter) {
              //BACK
              $scope.curFilter = $stateParams.curSearchFilter;
            }
            setCurFilterChips();
            $scope.search();
            //initMapLayers();
            setMapHeight();
          });
        });
      });
    })();
  },
];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/situationRecord/situationRecordSearchCtrl.js
// module id = 240
// module chunks = 0